import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Input,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { UtilService } from "../../../components/common/utils/util.service";
import { SiniestrosService } from "../siniestros.service";
import { ClienteXCiudad, ClienteLogin } from "../../login/cliente_login";
import { UsuarioLoginEntity } from "../../login/usuario_login_entity";
import { VehiculoEntity } from "../../masivos/datosGenerales/entities/vehiculo_entity";
import { AsistenciaMedicaEntity } from "../../masivos/datosGenerales/entities/asistencia_medica_entity";
import {
  Amparo,
  vTipoReclamoAsistencia,
  MensajeDocumentoServicio,
  vBeneficiarioAsistenciaMedica,
  DatosSiniestroAsistenciaMedica,
  vDiagnosticosAsistencia,
  ArchivoDocumentoAsitenciaMedica,
  MensajeSiniestro,
} from "../siniestros_entity";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { isNumber } from "util";

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
  selector: "reporte-siniestros-vO2O",
  templateUrl: "siniestro-reporte-vamO2O.template.html",
  providers: [SiniestrosService],
})
export class RerporteSiniestroVamO2OComponent implements OnInit {
  usuario: ClienteLogin;
  usuarioLogin: UsuarioLoginEntity;
  showLoader: string;
  userEmpresa: ClienteXCiudad;
  listAmparo: Amparo[] = new Array<Amparo>();
  listTipoReclamos: vTipoReclamoAsistencia[] = new Array<
    vTipoReclamoAsistencia
  >();
  idAmparo: number;
  tipoReclamo: string;
  documentos: MensajeDocumentoServicio[] = new Array<
    MensajeDocumentoServicio
  >();
  dependientes: vBeneficiarioAsistenciaMedica[] = new Array<
    vBeneficiarioAsistenciaMedica
  >();
  dependienteRcl: number;
  valorTotFacturas: number;
  datosReclamo: DatosSiniestroAsistenciaMedica = new DatosSiniestroAsistenciaMedica();
  listDiagnosticos: vDiagnosticosAsistencia[];
  current: number;
  docsCliente: ArchivoDocumentoAsitenciaMedica[] = new Array<
    ArchivoDocumentoAsitenciaMedica
  >();
  formData: FormData = new FormData();
  files: File[] = [];
  reclamo: DatosSiniestroAsistenciaMedica = new DatosSiniestroAsistenciaMedica();
  url: string = "utils";
  devolverMensaje: any;
  @Input()
  vamO2O: AsistenciaMedicaEntity;

  constructor(
    private router: Router,
    private sessionTokenService: SessionTokenService,
    private handleError: HandleError,
    public sesionStorageService: SessionStorageService,
    public utilsService: UtilService,
    public siniestrosService: SiniestrosService,

  ) {
    let constantService = new ConstantService();
    this.url = constantService.API_ENDPOINT + this.url;
    this.listAmparo = new Array<Amparo>();
    this.userEmpresa = new ClienteXCiudad();
    this.usuario = new ClienteLogin();
    this.dependienteRcl = undefined;
    this.datosReclamo = new DatosSiniestroAsistenciaMedica();
    this.datosReclamo.diagnostico = undefined;
    this.listDiagnosticos = new Array<vDiagnosticosAsistencia>();
    this.docsCliente = new Array<ArchivoDocumentoAsitenciaMedica>();
    this.formData = new FormData();
    this.devolverMensaje = (
      parametro: number,
      mensaje: any
    ): void => {
      if (parametro == 200) {
        let msj = JSON.parse(mensaje);
        swal({
          title: "Reclamo Guardado",
          text:
            "Su información ha sido enviada satisfactoriamente, el código de tracking es: #" + msj.numeroSiniestro,
          type: "success",
        });

        this.docsCliente = new Array<ArchivoDocumentoAsitenciaMedica>();
        this.dependienteRcl = undefined;
        this.tipoReclamo = undefined;
        this.showLoader = "";
        this.formData = new FormData();
        this.InicializaReclamo();
      } else {
        swal({
          title: "Reclamo",
          text:
            "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: "error",
        });
        this.showLoader = "";
        this.formData = new FormData();
      }
    };
  }
  ngOnInit() {
    this.docsCliente = new Array<ArchivoDocumentoAsitenciaMedica>();

    this.GetAmparos();
    this.GetTipoReclamos();
    this.siniestrosService
      .ConsultarPacientes(this.vamO2O)
      .subscribe((result) => {
        this.dependientes = result;
      });
    this.GetDiagnostico();

  }

  GetAmparos() {
    this.siniestrosService.ConsultaListadoAmparos().subscribe((result) => {
      this.listAmparo = result;
    });
  }
  GetTipoReclamos() {
    this.siniestrosService.ConsultaListaTipoReclamos().subscribe((result) => {
      this.listTipoReclamos = result;
    });
  }

  getDocumentos() {
    this.docsCliente = new Array<ArchivoDocumentoAsitenciaMedica>();
    this.siniestrosService
      .ConsultarDocumentosByAmparo(this.idAmparo, this.tipoReclamo)
      .subscribe((result) => {
        this.documentos = result;
      });

    //this.GetDiagnostico();
  }

  GetDiagnostico() {
    this.showLoader = "sk-loading";
    this.siniestrosService.ConsultaListaDiagnosticos().subscribe((result) => {
      this.listDiagnosticos = result;
      this.showLoader = "";
    });
  }

  CrearDocumento() {
    let a = this.docsCliente.length;
    let codigo = 1;

    codigo =
      Math.max.apply(
        Math,
        this.docsCliente.map(function (o) {
          return o.IdDocumento;
        })
      ) + 1;
    if (!isFinite(codigo)) {
      codigo = 1;
    }

    let doc = new ArchivoDocumentoAsitenciaMedica();
    doc.IdDocumento = codigo;
    //doc.TipoDocumento = tipCod;
    this.docsCliente.push(doc);
  }

  fileChange(archivo: any, doc: ArchivoDocumentoAsitenciaMedica) {
    let archivoEncontrado = undefined;
    if (this.files != undefined) {
      archivoEncontrado = this.files.filter(
        (a) => a.name == archivo.target.files[0].name
      );
    }
    if (
      archivoEncontrado != null &&
      archivoEncontrado != undefined &&
      archivoEncontrado.length > 0
    ) {
      swal({
        title: "Archivo ",
        text: "El nombre de archivo ya existe, por favor modifique su nombre",
        type: "error",
      });
    } else {
      doc.Descripcion = archivo.target.files[0].name;
      doc.TipoMIME = archivo.target.files[0].type;
      this.files.push(archivo.target.files[0]);
    }
  }
  eliminarArchivo(doc: ArchivoDocumentoAsitenciaMedica) {
    this.docsCliente = JSON.parse(
      JSON.stringify(
        this.docsCliente.filter((a) => a.IdDocumento != doc.IdDocumento)
      )
    );
    this.files = this.files.filter((a) => a.name != doc.Descripcion);
  }

  
  EnviarReclamo() {
    this.showLoader = "sk-loading";
    this.datosReclamo.amparo = this.idAmparo.toString(); //preguntar si es string;
    this.datosReclamo.medioReporte = 1909;
    this.datosReclamo.codigoCliente = this.vamO2O.CodCliente.toString();
    this.datosReclamo.codigoProducto = this.vamO2O.CodProducto.toString();
    this.datosReclamo.codigoBien = this.vamO2O.CodAccPer.toString();
    this.datosReclamo.poliza = this.vamO2O.Poliza;
    this.datosReclamo.ciudadOcurrencia = this.vamO2O.CiuCod.toString();
    this.datosReclamo.codBeneficiario = this.dependienteRcl;
    this.datosReclamo.Documentos = JSON.parse(JSON.stringify(this.docsCliente));
    this.datosReclamo.NombreTitular = this.vamO2O.NombreTitular;
    this.datosReclamo.tipoReclamo= Number(this.tipoReclamo);
    this.datosReclamo.NombrePaciente =  this.dependientes.filter(a => a.CODIGOBENEFICIARIO == this.dependienteRcl)[0].BENEFICIARIO;
    this.datosReclamo.celularContacto = this.vamO2O.TelefonoTitular.toString();
    this.datosReclamo.emailContacto = this.vamO2O.EmailTitular.toString();
    this.datosReclamo.rolEmpleado = this.vamO2O.EmpRol;
    this.datosReclamo.rolEmpleadoSiniestros = this.vamO2O.EmpRolSiniestros;

    this.files.forEach((a) => {
      this.formData.append(a.name, a, a.name);
    });

    this.formData.append("Reclamo", JSON.stringify(this.datosReclamo));

    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        this.devolverMensaje(xhr.status, xhr.response);
      }
    }.bind(this);
    xhr.open("post", this.url + "/GetGuardarReclamoVO2O", true);
    xhr.setRequestHeader("enctype", "multipart/form-data");
    // IE workaround for Cache issues
    xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.setRequestHeader("Cache-Control", "no-store");
    xhr.setRequestHeader("Pragma", "no-cache");
    xhr.setRequestHeader(
      "Authorization",
      "Token " + this.sesionStorageService.retrieve("Token")
    );
    xhr.setRequestHeader("Reclamos", JSON.stringify(this.datosReclamo));

    xhr.send(this.formData);
  }

  InicializaReclamo(){
    this.idAmparo=0;
    this.tipoReclamo=null;
    this.dependienteRcl=undefined;
    this.datosReclamo= new DatosSiniestroAsistenciaMedica();
    this.documentos=  new Array<MensajeDocumentoServicio>();
    this.datosReclamo.ValorPresentado=0;
  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/reporteSiniestros/siniestro-reporte-vamO2O.component.ts